import React, { useMemo } from 'react';
import { getBinMoistureDisplayRows } from '../utils/designMixMoistureUtils';

function DesignMixAggregateBins({ plantConfig = {}, moistureRecord, inputs = {}, onChange }) {
  const binRows = useMemo(
    () => getBinMoistureDisplayRows(plantConfig, moistureRecord, inputs),
    [plantConfig, moistureRecord, inputs],
  );

  return (
    <div className="table-bordered shadow p-2 my-2 border-secondary mb-3 bg-blue form-control-panel design-mix-recipe-panel">
      <h5 className="mb-2"><b>AGGREGATE BINS</b></h5>

      <div className="design-mix-bin-grid">
        <span className="design-mix-bin-head" title="Bin">Bin</span>
        <span className="design-mix-bin-head text-right" title="Target">Target</span>
        <span className="design-mix-bin-head text-right" title="Moisture %">Moist %</span>
        <span className="design-mix-bin-head text-right" title="Absorption %">Abs %</span>
        <span className="design-mix-bin-head text-right" title="Target (Corrected)">Corr. Target</span>
        <span className="design-mix-bin-head text-center" title="Material">Material</span>

        {binRows.map((bin) => (
          <React.Fragment key={bin.aggKey}>
            <label htmlFor={`bin_${bin.index}`} className="design-mix-bin-label mb-0 text-right">
              Bin {bin.index}
            </label>
            <input
              type="number"
              id={`bin_${bin.index}`}
              className="form-control totalval"
              disabled={!bin.enabled}
              style={{ cursor: bin.enabled ? 'auto' : 'not-allowed' }}
              name={bin.aggKey}
              onChange={onChange}
              value={inputs[bin.aggKey] ?? 0}
              min="0"
            />
            <input
              type="number"
              className="form-control design-mix-readonly-field"
              value={bin.enabled ? bin.moisture : ''}
              readOnly
              disabled
              tabIndex={-1}
              title="Moisture % from plant moisture correction"
            />
            <input
              type="number"
              className="form-control design-mix-readonly-field"
              value={bin.enabled ? bin.absorption : ''}
              readOnly
              disabled
              tabIndex={-1}
              title="Absorption % from plant moisture correction"
            />
            <input
              type="number"
              className="form-control design-mix-readonly-field"
              value={bin.enabled ? bin.correctedTarget : ''}
              readOnly
              disabled
              tabIndex={-1}
              title="Target after moisture correction"
            />
            <strong
              className="design-mix-bin-material text-center text-danger"
              title={bin.enabled ? bin.label : undefined}
            >
              {bin.enabled ? bin.label : null}
            </strong>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}

export default DesignMixAggregateBins;
